import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { PollVars } from 'src/models/pollVars.model';
import { DataService } from 'src/services/data.service';
import { PollsService } from 'src/services/polls.service';

@Component({
  selector: 'app-poll',
  templateUrl: './poll.component.html',
  styleUrls: ['./poll.component.scss']
})
export class PollComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  idPollType: any;
  campaign: any;
  ues21ApiUrl: any;
  clientId: any;

  constructor(private service: PollsService,
    private router: Router,
    private dataService: DataService,
    private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.idPollType = this.route.snapshot.paramMap.get("idPollType");
    this.campaign = this.route.snapshot.paramMap.get("campaign");
    this.ues21ApiUrl = this.service.getUes21ApiUrl();
    this.clientId = this.service.getClientId();
    this.route.queryParams.subscribe((params) => {
      if (params) {
        if (params.code) {
          this.registerPoll(params.code);
        } else {
          this.getAuthType();
        }
      }
    })
  }

  getAuthType() {
    this.blockUI.start();
    this.service.getAuthType(this.idPollType).subscribe((result: PollVars) => {
      localStorage.setItem("HeaderLogoUrl", result.headerLogo);
      localStorage.setItem("FooterLogoUrl", result.footerLogo);
      localStorage.setItem("idPollType", this.idPollType);
      switch (result.authType.toLowerCase()) {
        case "oauth":
          this.blockUI.stop();
          window.open(this.ues21ApiUrl + "authorize?client_id=" + this.clientId + "&response_type=code&redirect_uri=" + window.location.href.replace("start", "poll"), "_self")
          break;
        default:
          this.blockUI.stop();
          this.registerPoll();
          break;
      }
    }, (error) => {
      this.blockUI.stop();
      console.error(error);
    })
  }

  registerPoll(code?) {
    this.blockUI.start();
    this.service.getRegisterPoll(this.idPollType, this.campaign).subscribe((result) => {
      this.dataService.registerPoll = result;
      if (code) {
        this.dataService.code = code;
      }
      this.blockUI.stop();
      this.dataService.role = this.idPollType == this.service.getIdEncuestaCovidDocente() ? "CODOCENTE" : "EXTERNO";
      this.service.registerPoll = true;
      this.router.navigate(['/personalInformation']);
    }, (error) => {
      console.error(error);
    })
  }

}
